import * as React from "react";
import * as Loyalty from "@dotdev/reactive-rewards";

export const AddGiftToCartButton: React.FC<IProps> = ({
  variant,
  giftId
}) => {
  return (
    <Loyalty.Consumer>
      {({ benefits, cart }) => {
        const gift = benefits?.gifts.find((gift: { 
          gift_id: string 
        }) => gift.gift_id === giftId)
        return (
          <Loyalty.AddToCartButton 
            variant={variant}
            gift={gift}
            cart={cart}
          />
        )
      }}
    </Loyalty.Consumer>
  )
}

interface IProps {
  variant: {
    id: number;
    availableForSale: boolean;
    price: number;
    title: string;
    options: {
      name: string;
      value: string;
    }[];
  }
  giftId: string;
}